import { render, staticRenderFns } from "./vendors-rejected.vue?vue&type=template&id=49f492dd&scoped=true"
import script from "./vendors-rejected.vue?vue&type=script&lang=js"
export * from "./vendors-rejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f492dd",
  null
  
)

export default component.exports